import React, { useState } from 'react';
import api from '../services/api';

const InvitarClientePage = () => {
  const [form, setForm] = useState({ email: '', nombre_cliente: '', plan: 'trial', establecimiento_nombre: '' });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [history, setHistory] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const res = await api.post('/auth/invite', form);
      setResult(res.data);
      setHistory(prev => [{ ...form, date: new Date().toLocaleString('es'), url: res.data.invite_url }, ...prev]);
      setForm({ email: '', nombre_cliente: '', plan: 'trial', establecimiento_nombre: '' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al enviar invitacion');
    } finally { setLoading(false); }
  };

  const planes = [
    { value: 'demo', label: 'Demo / Trial (Gratis 30 dias - 500 animales)' },
    { value: 'basico', label: 'Basico ($9.99/mes - 1,000 animales)' },
    { value: 'profesional', label: 'Profesional ($24.99/mes - 3,500 animales)' },
    { value: 'enterprise', label: 'Plus ($49.99/mes - 12,000 animales)' },
    { value: 'corporativo', label: 'Enterprise (Cotizacion - Ilimitado)' },
  ];

  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto space-y-6" data-testid="invitar-page">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Invitar Nuevo Cliente</h2>
        <p className="text-sm text-gray-500 mt-1">Envia una invitacion por email para que un nuevo cliente se registre</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email del cliente *</label>
            <input
              type="email" required value={form.email}
              onChange={(e) => setForm(prev => ({ ...prev, email: e.target.value }))}
              placeholder="cliente@ejemplo.com"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              data-testid="invite-email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del cliente *</label>
            <input
              type="text" required value={form.nombre_cliente}
              onChange={(e) => setForm(prev => ({ ...prev, nombre_cliente: e.target.value }))}
              placeholder="Juan Perez"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              data-testid="invite-nombre"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Plan</label>
            <select
              value={form.plan}
              onChange={(e) => setForm(prev => ({ ...prev, plan: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              data-testid="invite-plan"
            >
              {planes.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del establecimiento</label>
            <input
              type="text" value={form.establecimiento_nombre}
              onChange={(e) => setForm(prev => ({ ...prev, establecimiento_nombre: e.target.value }))}
              placeholder="Estancia Don Pedro (opcional)"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              data-testid="invite-establecimiento"
            />
          </div>
        </div>

        <button
          type="submit" disabled={loading}
          className="w-full py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium disabled:opacity-50 transition"
          data-testid="send-invite-btn"
        >
          {loading ? 'Enviando...' : 'Enviar Invitacion'}
        </button>
      </form>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700" data-testid="invite-error">{error}</div>
      )}

      {result && (
        <div className="bg-green-50 border border-green-200 rounded-xl p-4" data-testid="invite-success">
          <p className="text-green-700 font-medium text-sm">{result.message}</p>
          <div className="mt-2 p-3 bg-white rounded-lg border">
            <p className="text-xs text-gray-500 mb-1">Link de registro (se envio por email):</p>
            <p className="text-sm font-mono text-gray-700 break-all">{result.invite_url}</p>
          </div>
        </div>
      )}

      {/* Invitation History */}
      {history.length > 0 && (
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h3 className="font-semibold text-gray-800 mb-3">Invitaciones enviadas esta sesion</h3>
          <div className="space-y-2">
            {history.map((h, i) => (
              <div key={i} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg text-sm">
                <div>
                  <span className="font-medium text-gray-800">{h.nombre_cliente}</span>
                  <span className="text-gray-500 ml-2">({h.email})</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs">{h.plan}</span>
                  <span className="text-xs text-gray-400">{h.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InvitarClientePage;
